import React from "react";
import { greenColor } from "../../../UI/DMCharts";

export const LoadingProgress = ({ current, total }) => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: "4px",
      background: "#f0f0f0",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        height: "100%",
        background: greenColor,
        width: `${(current / total) * 100}%`,
        transition: "width 0.3s ease-in-out",
      }}
    />
  </div>
);
